import { RichText } from '@/components/richText/RichText';
import { hasContent } from '@/helper/RichText';
import { resolveStory } from '@/helper/utils';
import ContactCard from '@/storyblok/contactCard/ContactCard';
import type {
  ComponentContactCardsStoryblok,
  EntityContactStoryblok,
  RichtextStoryblok,
} from '@/types/component-types-sb';
import { type ISbStoryData, storyblokEditable } from '@storyblok/react/rsc';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import classes from './ContactCards.module.scss';

const ContactCardsComponent: React.FC<{
  contacts?: (ISbStoryData<EntityContactStoryblok> | string)[];
  content?: RichtextStoryblok;
  headline?: ReactNode;
  contentHeadline?: ReactNode;
  blok?: ComponentContactCardsStoryblok;
}> = ({ contacts, content, headline, contentHeadline, blok }) => {
  const isSingle = contacts?.length === 1;
  let sbEditable = {};
  if (blok) {
    sbEditable = storyblokEditable(blok);
  }

  return (
    <div className={classes.contactCards}>
      {(headline || hasContent(content)) && (
        <div className={classes.contactCardsHeader}>
          {headline}
          {!isSingle && hasContent(content) && <RichText text={content} />}
        </div>
      )}
      <div id={blok?.anchor || undefined} className={classes.contactCardsWrapper} {...sbEditable}>
        {contacts &&
          contacts.length > 0 &&
          contacts?.map((contactStory, key: number) => {
            const contact = resolveStory(contactStory);
            if (contact) {
              return (
                <ContactCard
                  contact={contact?.content}
                  key={`contact-${contactStory}-${key}`}
                  className={classes.card}
                />
              );
            }
          })}
        {isSingle && (
          <div className={classes.singleText}>
            {contentHeadline}
            <RichText text={content} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactCardsComponent;
